GameView    = require "views/base/game"

class ChatView extends GameView
  template: require("./template")

  events: ->
    "iostap .selectable": "selectAnswer"
    "iostap .btn-done": "endGame"

  serialize: ->
    d = super
    answers = d.metadata?.questions?[0]?.answers or []

    d.allAnswers = _.shuffle(answers).map (a, i) ->
      id:        a.id
      text:      typogr.typogrify(a.content.toString() or "")
      isCorrect: a.correct
      delay:     6 + i * 2
    d

  onRefresh: ->
    super
    @resetChat(true)

  resetChat: (isRefresh) ->
    @setState("prompt")
    @setState(false, "show-msg")

    delay =
      if isRefresh then 0
      else if not @options.data.message.content then 300
      else 1000

    if @options.data.game?.timer.limit > 0
      for el in @getEl "answers"
        el.classList.add("no-delay")

    if isRefresh
      @getEl("chatElli").classList.add("hide")

    window.clearTimeout @timeout
    @timeout = window.setTimeout (=>
      @setState(true, "show-msg")
      @getEl("chatElli").classList.remove("hide")
    ), delay

  show: ->
    super
    @setEl @findAll(".selectable"), "answers"
    @setEl @findOne(".chat-msg-elli"), "chatElli"
    @resetChat()

    @enterGame()

  hide: ->
    @setState(false, "show-msg")
    super

  endGame: ->
    super

    @submit()

  selectAnswer: (e) ->
    return if @currentState.state is "complete"

    for el in @getEl "answers"
      el.classList.remove("active")
      @transform el, scale: 1

    target = e.currentTarget
    width  = target.offsetWidth
    target.classList.add("active", "no-delay")
    @transform target, scale: 1 + 16 / width

    @setEl(target, "selected")
    @setState("touched")

  answerDetails: ->
    questions = @options.metadata?.questions or []
    return [] unless questions.length > 0

    question = questions[0]
    id       = @getEl("selected")?.dataset.id

    details =
      answer: _.find(question.answers, { id })
      question: question.question
    [ details ]

  isCorrect: ->
    @getEl("selected")?.classList.contains("correct") ? false

  screenshot: ->
    @setState(true, "show-msg")

    super(arguments...)

module.exports = ChatView
